import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { isString } from '@util';

@Injectable()
export class PcsTranslateService {
  constructor(private translateService: TranslateService) {
  }

  /**
   * Returns a translation instantly from the loaded translation.
   * Message keys should use single braces {} to enclose parameters.
   *
   * @param {string} message Message key
   * @param {array} params Message params
   * @returns {string} translated message with applied parameters
   */
  translate(message: string, params: (string[] | any) = []): string {
    return isString(message)
      ? this.translateService.instant(message, params)
      : message;
  }

  changeLanguage(lang: string) {
    this.translateService.use(lang);
  }

  resetLanguage(lang: string) {
    this.translateService.resetLang(lang);
    this.translateService.currentLang = '';
  }

}
